import SelectCountries from "Components/InputsForm/SelectCountries";
import { NavLink } from "react-router-dom";
import i18next from "i18next";
import { TCountry } from "Utilities/Types";
import Name from "Components/InputsForm/Name";
import Email from "Components/InputsForm/Email";
import Phone from "Components/InputsForm/Phone";
import Error from "Components/InputsForm/Error";
import Textarea from "Components/InputsForm/Textarea";
import arrowBtn from "Assets/icons/arrow_left.svg";

// Hooks
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import useGetApi from "Hooks/useGetApi";
import useIsMobile from "Hooks/useIsMobile";

// Styles
import "../ContactForm.scss";
// import './nestedInput.scss';

const NestedInput = ({ sending }: { sending: boolean }) => {
  let lenguage =
    i18next.language === "sp" || i18next.language === "es-US" ? "es" : "en";
  const { data } = useGetApi<TCountry[]>(`api/countries?lang=${lenguage}`);
  const { t } = useTranslation();
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const countries = data;
  const countriesName = countries
    ? countries.map((country: TCountry) => country["name"])
    : [];

  const isMobile = useIsMobile();

  return (
    <>
      <div className="form_container">
        {/* Message */}
        <div className="form_box message">
          <label htmlFor="message">{t("contact.form.message")} *</label>
          <Textarea
            register={register}
            errors={errors}
            placeholder={isMobile ? t("contact.form.message") + " *" : ""}
          />
        </div>
        {/* Name */}
        <div className="form_box name">
          <label htmlFor="name">{t("contact.form.name")} *</label>
          <Name
            register={register}
            errors={errors}
            placeholder={isMobile ? t("contact.form.name") + " *" : ""}
          />
        </div>
        {/* Email */}
        <Email
          register={register}
          errors={errors}
          placeholder={isMobile ? t("contact.form.mail") + " *" : ""}
        />
        {/* Phone */}

        <Phone
          register={register}
          errors={errors}
          watch={watch}
          placeholder={
            isMobile ? t("contact.form.phonePlaceholder") + " *" : ""
          }
        />

        {/* Country */}
        <div className="form_box country">
          <label htmlFor="country">{t("contact.form.country")} *</label>
          <SelectCountries
            options={countriesName}
            placeholder={
              isMobile ? t("contact.form.country") + " *" : "Argentina"
            }
            register={register}
            errors={errors}
          />
          <Error error={errors.country} />
        </div>
        {/* Company */}
        <div className="form_box company">
          <label htmlFor="company">{t("contact.form.company")}</label>
          <input
            type="text"
            autoComplete="on"
            className="input input-focus"
            id="company"
            {...register("company")}
            placeholder={isMobile ? t("contact.form.company") + "" : ""}
          />
        </div>
        {/* Position */}
        <div className="form_box position">
          <label htmlFor="position">{t("contact.form.position")}</label>
          <input
            type="text"
            autoComplete="on"
            className="input input-focus"
            id="position"
            {...register("position")}
            placeholder={isMobile ? t("contact.form.position") + "" : ""}
          />
        </div>

        {/* Submit */}
        <div className="terms">
          <span id="terms-label">
            {t("contact.form.terms")}
            <NavLink to="/privacy">{t("contact.form.privacy")}</NavLink>
          </span>
        </div>
        <div className="form_box submit">
          <button
            name="submit"
            type="submit"
            className="submit-button"
            disabled={sending}
            aria-label={t("contact.form.button") || "Enviar"}
            style={{ display: "flex", gap: "0.25rem" }}
          >
            <img src={arrowBtn} width={24} height={24} alt="arrow rigth" />{" "}
            {sending ? (
              <>
                {t("contact.form.buttonSending")}
                <div className="loading-dots">
                  <div>.</div>
                  <div>.</div>
                  <div>.</div>
                </div>
              </>
            ) : (
              <>{t("contact.form.button")}</>
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default NestedInput;
